import * as React from 'react';
import {getActiveIndex} from '../../../../utils/pagination';
import GoToFirstPageLink from '../GoToFirstPageLink';
import GoToPreviousPageLink from '../GoToPreviousPageLink';
import GoToNextPageLink from '../GoToNextPageLink';
import GoToLastPageLink from '../GoToLastPageLink';
import {withTranslation} from 'react-i18next';
import s from './mobile.scss';
import {Experiment} from '../../../../reducers/experiments';

type MobileProps = {
  history?: History;
  data: any;
  makePagePath: (...args: any[]) => any;
  t?: (...args: any[]) => any;
  experiments: Experiment[];
};
class Mobile extends React.Component<MobileProps, {}> {
  render() {
    const {data, makePagePath} = this.props;
    const {range, first, last, next, previous} = data;
    const current = getActiveIndex(range);
    const currentPage = range[current].index;
    const hideForwardButton = last.index === currentPage;
    const hidePreviousButton = range[0].active;
    let mobileMobile = `${currentPage}/${last.index}`;
    return (
      <nav data-hooks="pagination-navigation" className={s.pagination}>
        <GoToFirstPageLink
          active={first.active}
          hide={hidePreviousButton || currentPage <= 2}
          path={makePagePath(first.index)}
          page={first.index}
        />
        <GoToPreviousPageLink
          active={previous.active}
          hide={hidePreviousButton}
          path={makePagePath(previous.index)}
          page={previous.index}
        />
        <li className={`${s.link} ${s.unActive}`}>{mobileMobile}</li>
        <GoToNextPageLink
          active={next.active}
          hide={hideForwardButton}
          path={makePagePath(next.index)}
          page={next.index}
        />
        <GoToLastPageLink
          active={last.active}
          hide={hideForwardButton || currentPage >= last.index - 1}
          path={makePagePath(last.index)}
          page={last.index}
        />
      </nav>
    );
  }
}
export default withTranslation()(Mobile);
